module.exports = "https://cdn.redage.net/src/views/player/help/images/mws.jpg";